const PANEL_TOOLTIP_MIN_WIDTH = 200;
const PANEL_TOOLTIP_MAX_WIDTH = 650;
const PANEL_TOOLTIP_MAX_HEIGHT = 500;
const PANEL_TOOLTIP_HORIZONTAL_SPACING = 2;
const PANEL_TOOLTIP_PADDING = 8;
const PIN_TOOLTIP_HELP_TEXT = 'Click chart to pin';
const UNPIN_TOOLTIP_HELP_TEXT = 'Unpin';
const isZRMouseEvent = (event)=>'zrX' in event && 'zrY' in event;
const DEFAULT_PANEL_TOOLTIP_CONFIG = {
    enabled: true,
    enablePinning: true
};
const PANEL_TOOLTIP_CONFIG_PINNING_DISABLED = {
    enabled: true,
    enablePinning: false
};
const PANEL_TOOLTIP_THROTTLE_MS = 150;
export { DEFAULT_PANEL_TOOLTIP_CONFIG, PANEL_TOOLTIP_CONFIG_PINNING_DISABLED, PANEL_TOOLTIP_HORIZONTAL_SPACING, PANEL_TOOLTIP_MAX_HEIGHT, PANEL_TOOLTIP_MAX_WIDTH, PANEL_TOOLTIP_MIN_WIDTH, PANEL_TOOLTIP_PADDING, PANEL_TOOLTIP_THROTTLE_MS, PIN_TOOLTIP_HELP_TEXT, UNPIN_TOOLTIP_HELP_TEXT, isZRMouseEvent };

//# sourceMappingURL=model.js.map